var _path, _circle, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNaverBlog = function SvgNaverBlog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 39 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h38v38H.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19,
    r: 17.417,
    fill: "#8C919F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.912 17.38a.683.683 0 1 0 0 1.364.683.683 0 0 0 0-1.365M20.657 17.308a.736.736 0 1 0 0 1.472.736.736 0 0 0 0-1.472"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.763 10.585H12.238a2.655 2.655 0 0 0-2.653 2.656v8.63a2.655 2.655 0 0 0 2.653 2.657h5.13l1.745 4.116s.12.356.41.356c.292 0 .411-.356.411-.356l1.746-4.116h5.083a2.655 2.655 0 0 0 2.654-2.656v-8.63a2.655 2.655 0 0 0-2.654-2.657m-10.949 7.63c-.008 1.577-1.637 1.622-1.637 1.622-.63 0-.986-.418-.986-.418v.284h-1.187v-4.9s-.005-.001 0-.002v.002c.075.012 1.187-.002 1.187-.002v1.873c.278-.477 1.085-.468 1.085-.468 1.757.164 1.537 2.008 1.537 2.008zm2.09-1.858v3.355h-1.16V16.39c0-.452-.561-.578-.561-.578v-1.17c1.855.075 1.721 1.714 1.721 1.714m2.753 3.483c-1.076 0-1.947-.804-1.947-1.794s.871-1.794 1.947-1.794 1.947.804 1.947 1.794-.871 1.794-1.947 1.794m6.363 0s.017 1.703-1.713 1.703h-.527V20.44h.318s.727.067.718-1.055c0 0-.141.454-1.16.454 0 0-1.447-.103-1.447-1.515v-.536s.034-1.464 1.621-1.58c0 0 .626-.068 1.012.45V16.3h1.178z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.174 17.325a.72.72 0 1 0 .001 1.439.72.72 0 0 0-.002-1.44"
  })));
};
export default SvgNaverBlog;